import React from 'react'

function RNproject() {
  return (
    <div className='mt-5 p-5'>
        This page is coming soon...
    </div>
  )
}

export default RNproject